<template>
  <hm-content>
    <div class="row-item flex item-center">
      <div class="label">规格类型</div>
      <el-input
        maxlength="20"
        size="small"
        v-model="typeName"
        style="width: 200px"
        placeholder="请输入规格，限制20字符内"
      ></el-input>
    </div>
    <div class="specValue-list">
      <div class="list-item" v-for="(v, i) in specModels" :key="i">
        <div class="row-item flex item-center">
          <div class="label">添加规格名称</div>
          <el-input
            maxlength="10"
            size="small"
            style="width: 200px"
            v-model.trim="v.specName"
            @input="setSpecificationName(v.specName, i)"
            placeholder="请输入规格名称"
          ></el-input>
          <div class="add-wrapper" v-if="i === 0">
            <span
              class="hmicon icon-hao pointer"
              @click="addSpecification"
            ></span>
          </div>
          <div class="minus-wrapper" v-else>
            <span
              class="hmicon icon-jianhao pointer"
              @click="deleteSpecification(i)"
            ></span>
          </div>
        </div>
        <div class="table" v-show="v.specValueList.length">
          <div class="table-header flex">
            <div class="flex-1 text-center">规格名称</div>
            <div class="flex-1 text-center">规格值</div>
            <!-- <div class="flex-1 text-center">图片</div> -->
            <div class="flex-1 text-center">操作</div>
          </div>
          <div class="table-body">
            <template v-for="(item, index) in v.specValueList">
              <div
                class="flex table-row item-center"
                v-if="item.delFlag === '0'"
                :key="index"
              >
                <div class="flex-1 text-center">{{ item.specName }}</div>
                <div class="flex-1 text-center">
                  <el-input
                    @input="filterGt('specValue', i,index)"
                    v-model.trim="item.specValue"
                    size="small"
                  ></el-input>
                </div>
                <!-- <div class="flex-1 text-center">
                  <img
                    v-if="item.specImg"
                    :src="item.specImg"
                    alt="图片"
                    @click="upload(i, index)"
                  />
                  <span
                    v-else
                    class="upload hmicon icon-shangchuantupian"
                    @click="upload(i, index)"
                  ></span>
                </div> -->
                <div class="flex-1">
                  <div class="add-wrapper flex flex-center" v-if="index === 0">
                    <span
                      class="hmicon icon-hao pointer"
                      @click="addChild(i)"
                    ></span>
                  </div>
                  <div class="minus-wrapper flex flex-center" v-else>
                    <span
                      class="hmicon icon-jianhao pointer"
                      @click="deleteChild(i, index)"
                    ></span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-wrapper text-center">
      <el-button size="small" type="primary" :disabled="!typeName" @click="save"
        >保存</el-button
      >
      <el-button size="small" @click="back">返回</el-button>
    </div>
    <my-upload
      field="file"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      noCircle
      noSquare
      :width="26"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'goodsCenter' }"
      :height="26"
      :url="$uploadUrl"
      specImg-format="png"
    ></my-upload>
  </hm-content>
</template>

<script>
import myUpload from "vue-image-crop-upload";
import { mapGetters } from "vuex";
export default {
  components: {
    myUpload
  },
  data() {
    return {
      show: false,
      currentParent: "",
      currentChild: "",
      typeName: "",
      specModels: [
        {
          specName: "",
          specValueList: [
            {
              specName: "",
              specValue: "",
              specImg: ""
            }
          ]
        }
      ]
    };
  },
  computed: mapGetters(["specificationEditDetails"]),
  watch: {
    specificationEditDetails(val) {
      this.typeName = val.typeName;
      val.specModels.forEach(v => {
        v.specValueList.forEach(o => {
          o.specName = v.specName;
        });
      });
      this.specModels = val.specModels;
    }
  },
  created() {
    this.$store.dispatch("querySpecificationEditDetails", {
      typeId: this.$route.query.id
    });
  },
  mounted() {},
  methods: {
    save() {
      const isNoSpecificationName = this.specModels.find(v => !v.specName);
      let isNoSpecifacationValue = false;
      let isCommon = false;
      this.specModels.map((v, i) => {
        this.specModels.map((o, index) => {
          if (v.specName === o.specName && i !== index) {
            isCommon = true;
          }
        });
        v.specValueList.map(o => {
          if (!o.specValue) {
            isNoSpecifacationValue = true;
          }
        });
      });
      if (isNoSpecificationName || isNoSpecifacationValue || isCommon) {
        this.$message({
          type: "warning",
          message: "请填写规格名称和规格值,且规格名不能重复"
        });
      } else {
        this.$store
          .dispatch("editSpecification", {
            specModels: this.specModels,
            typeName: this.typeName,
            typeId: this.$route.query.id
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
      }
    },
    back() {
      this.$router.back(-1);
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      const url = jsonData.result;
      this.specModels[this.currentParent].specValueList[
        this.currentChild
      ].specImg = url;
    },
    setSpecificationName(specName, i) {
      this.specModels[i].specValueList.forEach(v => {
        v.specName = specName;
      });
    },
    addSpecification() {
      this.specModels.push({
        specName: "",
        specValueList: [
          {
            specName: "",
            specValue: "",
            specImg: "",
            delFlag: "0"
          }
        ]
      });
    },
    deleteSpecification(i) {
      this.specModels.splice(i, 1);
    },
    addChild(i) {
      this.specModels[i].specValueList.push({
        specName: this.specModels[i].specName,
        specValue: "",
        specImg: "",
        delFlag: "0"
      });
    },
    upload(i, index) {
      this.show = true;
      this.currentParent = i;
      this.currentChild = index;
    },
    deleteChild(i, index) {
      this.specModels[i].specValueList[index].delFlag = "1";
    },
    filterGt(prop,i,index) {
      this.specModels[i].specValueList[index][prop] = this.specModels[i].specValueList[index][prop].replace(";", ""); //过滤0开头
      this.specModels[i].specValueList[index][prop] = this.specModels[i].specValueList[index][prop].replace("；", ""); //过滤0开头
      this.specModels[i].specValueList[index][prop] = this.specModels[i].specValueList[index][prop].replace(",", ""); //过滤0开头
      this.specModels[i].specValueList[index][prop] = this.specModels[i].specValueList[index][prop].replace("，", ""); //过滤0开头
    },
  }
};
</script>
<style lang="scss" scoped>
.row-item {
  margin-bottom: 20px;
  .label {
    font-size: 14px;
    font-weight: bold;
    width: 100px;
    text-align: right;
    margin-right: 10px;
  }
}
.add-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  margin-left: 10px;
  .hmicon {
    font-size: 14px;
  }
}

.minus-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #e50065;
  margin-left: 10px;
  box-sizing: border-box;
  .hmicon {
    color: #e50065;
    font-size: 14px;
  }
}

.upload {
  font-size: 26px;
  color: #0081e5;
}

.list-item {
  margin-bottom: 20px;
}
.table {
  border: 1px solid #ddd;
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }
  .table-row:nth-child(even) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}
</style>
